import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V3 } from '@studio/constants/env-variables';
import type { SoftwareEncoders } from '@studio/types';

export const root = {
  [HTTP_METHODS.POST]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/uploaders/registration`,
    request: {} as SoftwareEncoders.Post.AddEncoderName,
    response: {} as { token: string },
    method: HTTP_METHODS.POST,
  },
};
